import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between w-full pr-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-lg text-textPrimary" }, " Editar política de qualificação para repasse ", -1)
const _hoisted_3 = { class: "flex flex-col gap-2 p-4 flex-1 min-h-0" }
const _hoisted_4 = { class: "flex flex-col gap-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-textPrimary text-left font-semibold" }, " Vigência do vínculo entre escala e a política ", -1)
const _hoisted_6 = { class: "flex flex-wrap items-center gap-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-[#666] text-left" }, " Marque Sim ou Não para cada critério. O salvamento dispara avaliação de pós-plantão nos plantões pendentes deste médico. ", -1)
const _hoisted_8 = { class: "flex flex-col md:flex-row items-start md:items-center gap-4" }
const _hoisted_9 = {
  class: "w-[327px] shrink-0",
  style: {"height":"40px"}
}
const _hoisted_10 = { class: "ml-auto" }
const _hoisted_11 = { class: "flex items-center justify-between" }
const _hoisted_12 = {
  class: "text-sm text-gray-600",
  "data-testid": "edit-qualification-doctor-count"
}
const _hoisted_13 = { class: "overflow-auto flex-1 rounded-lg shadow-sm border border-gray-200 min-h-[300px]" }
const _hoisted_14 = {
  key: 0,
  class: "animate-pulse space-y-4 p-6"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "h-9 w-9 bg-gray-200 rounded-full" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1 space-y-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-4 bg-gray-200 rounded w-1/3" }),
  /*#__PURE__*/_createElementVNode("div", { class: "h-3 bg-gray-200 rounded w-1/5" })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "h-6 w-12 bg-gray-200 rounded-full" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "h-6 w-12 bg-gray-200 rounded-full" }, null, -1)
const _hoisted_19 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "flex items-center gap-2" }
const _hoisted_21 = { class: "flex items-center gap-2" }
const _hoisted_22 = ["data-testid", "onClick"]
const _hoisted_23 = { class: "flex gap-6 w-full" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-4 py-4 px-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "flex items-center justify-center shrink-0",
      style: {"width":"32px","height":"32px","border-radius":"100px","border":"1px solid #f1c21b","background":"#fef9e7"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "text-warning font-bold text-sm leading-none" }, "!")
    ]),
    /*#__PURE__*/_createElementVNode("h3", {
      class: "font-bold text-lg text-textPrimary",
      "data-testid": "discard-changes-title"
    }, " Descartar alterações? ")
  ]),
  /*#__PURE__*/_createElementVNode("p", {
    class: "text-sm text-gray-600",
    "data-testid": "discard-changes-description"
  }, " Você tem alterações não salvas. Ao sair, as alterações serão descartadas e esse processo não poderá ser revertido. ")
], -1)
const _hoisted_25 = { class: "flex gap-4 w-full" }

import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { mdiChevronDown, mdiTrashCanOutline } from '@mdi/js'
import { useToast } from 'vue-toastification'

import { useQualificationTransferPolicyStore } from '@/pinia-store/useQualificationTransferPolicyStore'
import { useErrorToast } from '@/composables/useErrorToast'
import Network from '@/Network'
import type { ToggleDoctorFieldRequest } from '@/Network/Types/Requests/QualificationTransferRequests'
import type {
  QualificationTransferPolicyItem,
  QualificationTransferDoctor
} from '@/Network/Types/Responses/QualificationTransferResponses'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import EditableHeader from '@/components/designSystem/Inputs/EditableHeader.vue'
import GenericInput from '@/components/designSystem/Inputs/GenericInput.vue'
import SearchInput from '@/components/designSystem/Inputs/SearchInput.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import Checkbox from '@/components/designSystem/Checkbox/index.vue'
import TableModular from '@/components/designSystem/Table/TableModular/TableModular.vue'
import DsSwitch from '@/components/designSystem/Switch/index.vue'
import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import EmptyList from '@/components/EmptyList.vue'
import DoctorCell from '@/modules/company/Policy/QualificationTransfer/components/DoctorCell.vue'
import AddDoctorModal from '@/modules/company/Policy/QualificationTransfer/components/AddDoctorModal.vue'
import ConfirmDeleteModal from '@/components/designSystem/modals/confirm.delete.action.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'QualificationPolicyModal',
  props: {
    modalActive: { type: Boolean },
    policy: {},
    scheduleId: {},
    linkId: {}
  },
  emits: ["close", "saved"],
  setup(__props: any, { emit }) {

const props = __props;





// `toast` fica apenas para o sucesso e para as validações locais do formulário;
// todo erro vindo da API passa pelo `notifyError` (rule `error-handling.md`).
const toast = useToast()
const { notifyError } = useErrorToast()
const store = useQualificationTransferPolicyStore()
const { doctors, totalDoctors, isDoctorsLoading } = storeToRefs(store)

const isSaving = ref(false)
const isDirty = ref(false)

const policyName = ref('')
const startDate = ref('')
const endDate = ref('')
const isIndefiniteEnd = ref(false)
const searchText = ref('')
const includeInvited = ref(false)
const showAddDoctorModal = ref(false)
const showRemoveConfirm = ref(false)
const doctorToRemove = ref<number | null>(null)
const showDiscardConfirm = ref(false)

const doctorColumns = [
  { key: 'name', label: 'MÉDICO' },
  { key: 'hasBankData', label: 'DADOS BANCÁRIOS' },
  { key: 'hasPaymentCriteria', label: 'CRITÉRIOS PARA PAGAMENTO' }
]

function toDateInputValue(iso: string | null | undefined): string {
  if (!iso) return ''
  return iso.includes('T') ? iso.split('T')[0] : iso
}

function initFormFromPolicy(policy: QualificationTransferPolicyItem) {
  policyName.value = policy.policyName
  startDate.value = toDateInputValue(policy.startDate)
  endDate.value = toDateInputValue(policy.endDate)
  isIndefiniteEnd.value = !policy.endDate
  isDirty.value = false
  showDiscardConfirm.value = false
}

watch(
  () => props.modalActive,
  (active) => {
    if (active && props.policy) {
      initFormFromPolicy(props.policy)
      fetchDoctors()
    } else {
      store.$reset()
    }
  }
)

function markDirty() {
  isDirty.value = true
}

function handleAttemptClose() {
  if (isDirty.value) {
    showDiscardConfirm.value = true
  } else {
    emit('close')
  }
}

function confirmDiscard() {
  showDiscardConfirm.value = false
  emit('close')
}

function cancelDiscard() {
  showDiscardConfirm.value = false
}

function handleIndefiniteToggle(value: boolean) {
  if (value) {
    endDate.value = ''
  }
  markDirty()
}

async function fetchDoctors() {
  if (!props.policy) return
  try {
    await store.fetchDoctors(props.policy.id, {
      q: searchText.value || undefined,
      includeInvited: includeInvited.value
    })
  } catch (e) {
    notifyError(e, 'Erro ao carregar médicos.')
  }
}

// Na falha a modal fica aberta, com a seleção, para o usuário tentar de novo.
async function handleConfirmAddDoctors(doctorIds: number[]) {
  if (!props.policy) return
  try {
    await store.addDoctors(props.policy.id, doctorIds)
    showAddDoctorModal.value = false
  } catch (e) {
    notifyError(e, 'Erro ao adicionar médicos à política.')
  }
}

async function toggleField(policyId: number, params: ToggleDoctorFieldRequest) {
  try {
    await store.toggleDoctorField(policyId, params)
  } catch (e) {
    notifyError(e, 'Erro ao atualizar dados do médico.')
  }
}

function handleToggleInvited({ isChecked }: { isChecked: boolean }) {
  includeInvited.value = isChecked
  fetchDoctors()
}

function handleToggleBankData(doctorId: number, value: boolean) {
  if (!props.policy) return
  toggleField(props.policy.id, { doctorId, field: 'hasBankData', value })
  markDirty()
}

function handleTogglePaymentCriteria(doctorId: number, value: boolean) {
  if (!props.policy) return
  toggleField(props.policy.id, { doctorId, field: 'hasPaymentCriteria', value })
  markDirty()
}

function handleRemoveDoctor(doctorId: number) {
  doctorToRemove.value = doctorId
  showRemoveConfirm.value = true
}

async function confirmRemoveDoctor() {
  if (doctorToRemove.value == null || !props.policy) return
  const doctorId = doctorToRemove.value
  markDirty()
  showRemoveConfirm.value = false
  doctorToRemove.value = null
  try {
    await store.removeDoctor(props.policy.id, doctorId)
  } catch (e) {
    notifyError(e, 'Erro ao remover médico da política.')
  }
}

function cancelRemoveDoctor() {
  showRemoveConfirm.value = false
  doctorToRemove.value = null
}

function validateForm(): string | null {
  if (!policyName.value.trim()) return 'Informe o nome da política.'
  if (!startDate.value) return 'Informe a data de início da vigência.'
  if (!isIndefiniteEnd.value && !endDate.value)
    return 'Informe a data de fim da vigência ou marque como indeterminado.'
  return null
}

async function updateExistingPolicy(): Promise<void> {
  if (!props.policy || !props.scheduleId || !props.linkId) {
    throw new Error('policy, scheduleId e linkId são obrigatórios para edição')
  }

  await Network.qualificationTransferPolicy.updatePolicy(props.policy.id, {
    name: policyName.value.trim()
  })

  await Network.qualificationTransferPolicy.updateScheduleLink(props.scheduleId, props.linkId, {
    startDate: startDate.value || undefined,
    endDate: isIndefiniteEnd.value ? null : endDate.value || undefined
  })

  toast.success('Política atualizada com sucesso.')
}

async function handleSave() {
  const error = validateForm()
  if (error) {
    toast.error(error)
    return
  }

  try {
    isSaving.value = true
    await updateExistingPolicy()
    emit('saved')
    emit('close')
  } catch (e) {
    notifyError(e, 'Não foi possível salvar a política.')
  } finally {
    isSaving.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalVue, {
      "modal-active": _ctx.modalActive,
      "max-width": "!w-[1050px] !max-w-[1050px]",
      "has-header-border": true,
      "has-footer-border": true,
      onClose: handleAttemptClose
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          (isDirty.value)
            ? (_openBlock(), _createBlock(LabelBadge, {
                key: 0,
                label: "Edições não salvas",
                color: "orange",
                size: "small",
                "data-testid": "edit-qualification-unsaved-badge"
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createVNode(OutlineButton, {
            class: "flex-1",
            text: "Cancelar",
            height: "48px",
            "data-testid": "edit-qualification-cancel-button",
            onClick: handleAttemptClose
          }),
          _createVNode(FilledButton, {
            class: "flex-1",
            color: "primary30",
            text: "Salvar",
            height: "48px",
            loading: isSaving.value,
            "data-testid": "edit-qualification-save-button",
            onClick: handleSave
          }, null, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(EditableHeader, {
            modelValue: policyName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((policyName).value = $event)),
            placeholder: "Nome da política",
            "data-testid": "edit-qualification-policy-name",
            onSave: markDirty
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(GenericInput, {
                modelValue: startDate.value,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((startDate).value = $event)),
                  markDirty
                ],
                type: "date",
                label: "Início da vigência",
                density: "compact",
                "hide-details": "",
                class: "max-w-[200px]",
                "data-testid": "edit-qualification-start-date"
              }, null, 8, ["modelValue"]),
              _createVNode(GenericInput, {
                modelValue: endDate.value,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((endDate).value = $event)),
                  markDirty
                ],
                type: "date",
                label: "Fim da vigência",
                density: "compact",
                "hide-details": "",
                disabled: isIndefiniteEnd.value,
                class: "max-w-[200px]",
                "data-testid": "edit-qualification-end-date"
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode(DsSwitch, {
                modelValue: isIndefiniteEnd.value,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => ((isIndefiniteEnd).value = $event)),
                  handleIndefiniteToggle
                ],
                label: "Fim de vigência indeterminado",
                "data-testid": "edit-qualification-indefinite-toggle"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(SearchInput, {
                modelValue: searchText.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchText).value = $event)),
                width: "100%",
                label: "Buscar médico",
                "hide-details": "",
                density: "compact",
                "search-function": fetchDoctors,
                "data-testid": "edit-qualification-search-doctor"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(OutlineButton, {
                text: "Adicionar médico",
                width: "auto",
                height: "32px",
                "prepend-icon": _unref(mdiChevronDown),
                class: "text-sm !w-auto !px-4 !py-1",
                "data-testid": "edit-qualification-add-doctor-button",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (showAddDoctorModal.value = true))
              }, null, 8, ["prepend-icon"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(totalDoctors)) + " médicos encontrados ", 1),
            _createVNode(Checkbox, {
              checked: includeInvited.value,
              fieldId: "edit-qualification-include-invited",
              label: "Incluir médicos convidados",
              "data-testid": "edit-qualification-include-invited-checkbox",
              "onUpdate:checked": handleToggleInvited
            }, null, 8, ["checked"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_unref(isDoctorsLoading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                    return _createElementVNode("div", {
                      key: i,
                      class: "flex items-center gap-4"
                    }, _hoisted_19)
                  }), 64))
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_unref(doctors).length > 0)
                    ? (_openBlock(), _createBlock(TableModular, {
                        key: 0,
                        rows: _unref(doctors),
                        columns: doctorColumns,
                        "actions-label": "AÇÕES"
                      }, {
                        "column-name": _withCtx(({ row }) => [
                          _createVNode(DoctorCell, {
                            doctor: row as QualificationTransferDoctor
                          }, null, 8, ["doctor"])
                        ]),
                        "column-hasBankData": _withCtx(({ row }) => [
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(LabelBadge, {
                              label: row.hasBankData ? 'Sim' : 'Não',
                              color: row.hasBankData ? 'green' : 'red',
                              size: "small",
                              icon: null
                            }, null, 8, ["label", "color"]),
                            _createVNode(DsSwitch, {
                              "model-value": row.hasBankData,
                              size: "small",
                              "data-testid": `edit-qualification-toggle-bank-data-${row.id}`,
                              "onUpdate:modelValue": (val) => handleToggleBankData(row.id, val)
                            }, null, 8, ["model-value", "data-testid", "onUpdate:modelValue"])
                          ])
                        ]),
                        "column-hasPaymentCriteria": _withCtx(({ row }) => [
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(LabelBadge, {
                              label: row.hasPaymentCriteria ? 'Sim' : 'Não',
                              color: row.hasPaymentCriteria ? 'green' : 'red',
                              size: "small",
                              icon: null
                            }, null, 8, ["label", "color"]),
                            _createVNode(DsSwitch, {
                              "model-value": row.hasPaymentCriteria,
                              size: "small",
                              "data-testid": `edit-qualification-toggle-payment-criteria-${row.id}`,
                              "onUpdate:modelValue": (val) => handleTogglePaymentCriteria(row.id, val)
                            }, null, 8, ["model-value", "data-testid", "onUpdate:modelValue"])
                          ])
                        ]),
                        actions: _withCtx(({ row }) => [
                          _createElementVNode("button", {
                            class: "p-1 rounded hover:bg-red-50 text-gray-400 hover:text-red-500 transition-colors",
                            "data-testid": `edit-qualification-remove-doctor-button-${row.id}`,
                            onClick: ($event: any) => (handleRemoveDoctor(row.id))
                          }, [
                            _createVNode(_component_v_icon, {
                              icon: _unref(mdiTrashCanOutline),
                              size: "20"
                            }, null, 8, ["icon"])
                          ], 8, _hoisted_22)
                        ]),
                        _: 1
                      }, 8, ["rows"]))
                    : (_openBlock(), _createBlock(EmptyList, {
                        key: 1,
                        title: "Nenhum médico encontrado",
                        class: "py-12"
                      }))
                ], 64))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modal-active"]),
    _createVNode(ModalVue, {
      "modal-active": showDiscardConfirm.value,
      "is-filter-modal": "",
      "show-close-button": false,
      "has-footer-border": false,
      onClose: cancelDiscard
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(OutlineButton, {
            class: "flex-1",
            text: "Descartar alterações",
            height: "48px",
            "data-testid": "discard-changes-confirm-button",
            onClick: confirmDiscard
          }),
          _createVNode(FilledButton, {
            class: "flex-1",
            color: "primary30",
            text: "Voltar",
            height: "48px",
            "data-testid": "discard-changes-cancel-button",
            onClick: cancelDiscard
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_24
      ]),
      _: 1
    }, 8, ["modal-active"]),
    (props.policy)
      ? (_openBlock(), _createBlock(AddDoctorModal, {
          key: 0,
          "modal-active": showAddDoctorModal.value,
          "policy-id": props.policy?.id ?? 0,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (showAddDoctorModal.value = false)),
          onAdd: handleConfirmAddDoctors
        }, null, 8, ["modal-active", "policy-id"]))
      : _createCommentVNode("", true),
    _createVNode(ConfirmDeleteModal, {
      show: showRemoveConfirm.value,
      title: "Confirmar remoção",
      description: "Tem certeza que deseja remover este médico da política?",
      "text-button": "Remover",
      onCloseModal: cancelRemoveDoctor,
      onHandleConfirm: confirmRemoveDoctor
    }, null, 8, ["show"])
  ], 64))
}
}

})